export class DropdownMenuToggle {
  expandedClass: string;
  target: HTMLElement;
  toggleElement: HTMLButtonElement;

  constructor(toggleElement: HTMLButtonElement) {
    this.toggleElement = toggleElement;
    this.target = document.getElementById(
      toggleElement.getAttribute("data-dropdown-target") || ""
    ) as HTMLElement;

    this.expandedClass =
      toggleElement.getAttribute("data-dropdown-expanded-class") || "";
  }

  addEventListeners = () => {
    // Remove any event listeners that exist so calling this
    // method twice doesn't cause undesired behavior.
    this.removeEventListeners();

    this.toggleElement.addEventListener("click", this.toggle);
  };

  removeEventListeners = () => {
    this.toggleElement.removeEventListener("click", this.toggle);
    window.removeEventListener("click", this._handleClickAway);
    window.removeEventListener("keydown", this._handleEscapeKey);
  };

  toggle = () => {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  };

  isOpen = () => {
    return this.toggleElement.getAttribute("aria-expanded")?.toLowerCase() ===
      "true"
      ? true
      : false;
  };

  open = () => {
    this.target.classList.add(this.expandedClass);
    this.toggleElement.setAttribute("aria-expanded", "true");

    window.addEventListener("click", this._handleClickAway);
    window.addEventListener("keydown", this._handleEscapeKey);
  };

  close = () => {
    this.target.classList.remove(this.expandedClass);
    this.toggleElement.setAttribute("aria-expanded", "false");

    window.removeEventListener("click", this._handleClickAway);
    window.removeEventListener("keydown", this._handleEscapeKey);
  };

  _handleClickAway = (event: Event) => {
    if (!event.target) return;
    if (this.target.contains(event.target as Node)) return;

    this.close();
  };

  _handleEscapeKey = (event: KeyboardEvent) => {
    if (event.key !== "Escape") return;

    this.close();
  };
}
